import React from 'react';
import { PropTypes } from 'prop-types';
import config from 'nordic/config';
import { AndesProvider } from '@andes/context';
import { ImageProvider } from 'nordic/image';
import { getImagesPrefix } from '@/utils';
import SharedPropsContext from '@/contexts/SharedProps';
import { getGeneralContent } from '../ui-components/buyer/content/general';
import {
  CategoriesSection,
  DisclaimerSection,
  EducationalSection,
  FaqSection,
  FooterSection,
  HeroSection,
  WaveSection,
} from '../ui-components/buyer/components';
import MarketingSection from '../ui-components/buyer/components/MarketingSection';

const BuyersPage = (props) => {
  const { sharedProps, foundLocale } = props;

  return (
    <AndesProvider locale={foundLocale}>
      <SharedPropsContext.Provider value={sharedProps}>
        <ImageProvider prefix={sharedProps.prefix}>
          <div className={`buyers ${sharedProps.siteId}`}>
            <HeroSection />
            <EducationalSection />
            <MarketingSection />
            <CategoriesSection />
            <WaveSection>
              <FaqSection />
              <FooterSection />
              <DisclaimerSection />
            </WaveSection>
          </div>
        </ImageProvider>
      </SharedPropsContext.Provider>
    </AndesProvider>
  );
};

BuyersPage.propTypes = {
  foundLocale: PropTypes.string,
  sharedProps: PropTypes.shape({
    prefix: PropTypes.string,
    siteId: PropTypes.string,
  }),
};

export default BuyersPage;

export const getServerSideProps = (req, res) => {
  const {
    i18n,
    locale,
    platform: { siteId },
    device,
    platform,
    originalUrl,
  } = req;

  const foundLocale = locale || i18n.locale;

  const { title } = getGeneralContent({ i18n });

  const {
    availableSeasonal,
    helpLinks,
    links,
    openSeaUrl,
    tracks,
    categories,
    hasCreditLine,
    isYellowTheme,
    seeCategories,
    webViewDeeplink,
    deeplinkSpecificCategories,
  } = res.locals;

  const {
    assets: { prefix },
    apiPicture,
  } = config;

  const imagesPrefix = getImagesPrefix({ isYellowTheme, configPrefix: prefix });

  const sharedProps = {
    serverDateTime: new Date().toString(),
    availableSeasonal,
    deviceType: device.type,
    helpLinks,
    isMobile: device.mobile,
    isWebView: device.webView,
    lowEnd: device.lowEnd,
    openSeaUrl,
    platform: platform.id,
    prefix: imagesPrefix,
    siteId,
    tracks,
    categories,
    links,
    baseUrl: originalUrl,
    apiPicture,
    hasCreditLine,
    isYellowTheme,
    seeCategories,
    webViewDeeplink,
    deeplinkSpecificCategories,
  };

  const props = {
    foundLocale,
    sharedProps,
  };

  const settings = {
    title,
    navigation: { type: 'lite' },
    melidata: tracks.melidata.pageView,
    analytics: tracks.analytics.pageTracks,
    layout: {
      panelLayout: { title: '' },
      staticMarkup: false,
    },
  };

  return { props, settings };
};

export const setPageSettings = ({ settings }) => settings;
